import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';

const Blogs = () => {
    const [blogs,setBlogs]=useState([])

    return (
        <Container>

<h1>Oops! Blogs section is still under development</h1>

        </Container>
    );
};

export default Blogs;